import { render, staticRenderFns } from "./LinkFriendCell.vue?vue&type=template&id=cbc97740&scoped=true&"
import script from "./LinkFriendCell.vue?vue&type=script&lang=babel&"
export * from "./LinkFriendCell.vue?vue&type=script&lang=babel&"
import style0 from "./LinkFriendCell.vue?vue&type=style&index=0&id=cbc97740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc97740",
  null
  
)

export default component.exports